/* eslint-disable local/i18n-require-translation-wrappers */
import GoHome from '@assets/images/GoHome.gif'
import AppPaths from '@globals/paths'
import useFeatureFlags, { FEATURE_FLAGS, FeatureFlagName } from '@globals/useFeatureFlags'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import MediaImage from '@shared/components/MediaImage'
import { Link as RouterLink } from 'react-router'

const FeatureFlagsForm = () => {
  return (
    <Container>
      <Stack spacing={2}>
        <Typography variant="h1">Feature Flags</Typography>
        <Paper sx={{ padding: 2 }}>
          <FormControl component="fieldset" variant="standard">
            <FeatureFlags />
          </FormControl>
        </Paper>
      </Stack>
    </Container>
  )
}

const FeatureFlags = () => {
  const { flags, toggleFlag } = useFeatureFlags()

  const handleToggleFlag = (flagName: FeatureFlagName) => () => toggleFlag(flagName)

  return (
    <FormGroup>
      <Stack>
        {FEATURE_FLAGS.map(f => (
          <FormControlLabel
            key={f}
            control={
              <Switch checked={flags[f]} onChange={handleToggleFlag(f as FeatureFlagName)} />
            }
            label={f}
          />
        ))}
      </Stack>
      <Box component={RouterLink} to={AppPaths.tenant.home()}>
        <MediaImage imgSrc={GoHome} maxWidth={320} maxHeight={320} backgroundColor="transparent" />
      </Box>
    </FormGroup>
  )
}

export default FeatureFlagsForm
